import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { useTranslation } from 'react-i18next';

interface ContextInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const ContextInput: React.FC<ContextInputProps> = ({
  value,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Textarea
        id="context"
        className="bg-card"
        placeholder={t('context.placeholder.translation')}
        rows={5}
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        autogrow
      />
    </div>
  );
};

export default ContextInput;
